import * as yup from "yup";

export const schema = (t: (key: string) => string) => {
  return yup
    .object({
      height: yup
        .string()
        .required(t("login.input.username.validations.emptyText")),
      width: yup
        .string()
        .required(t("login.input.password.validations.emptyText")),
      depth: yup
        .string()
        .required(t("login.input.password.validations.emptyText")),
    })
    .required();
};
